export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const TOWER = 'TOWER';
export const DIALOG = 'DIALOG'; 